import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ENV } from "@app/constants/env";
import { SustainabilityReportEntity, SustainabilityReportRequestEntity } from '@feature/types/jobservice.type';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { getToken } from '@app/helpers/authProvider';

const rawBaseQuery = fetchBaseQuery({
    baseUrl: ENV.BASE_API_URL +ENV.JOB_APIURL,
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    incomingArgs,
    api,
    extraOptions
) => {
    let args: string | FetchArgs = incomingArgs;

    // normalize string arg to object so we can set headers
    if (typeof args === 'string') {
        args = { url: args };
    }

    try {
        const token = await getToken(); // ensure this returns a non-empty string
        //const token = sessionStorage.getItem('accessToken'); // Replace 'authToken' with the actual key used in sessionStorage
        if (token) {
            const headers =
                (args as FetchArgs).headers instanceof Headers
                    ? (args as FetchArgs).headers
                    : new Headers((args as FetchArgs).headers);

            headers.set('Authorization', `Bearer ${token}`); // use standard casing
            (args as FetchArgs).headers = headers;
        }

        const result = await rawBaseQuery(args, api, extraOptions);

        // optional: retry once if unauthorized (adjust getToken refresh logic if available)
        if (result.error && result.error.status === 401 && token) {
            // If you have a refresh flow, invoke it here then retry.
            // const refreshed = await getRefreshedToken();
            // if (refreshed) { headers.set('Authorization', `Bearer ${refreshed}`); return rawBaseQuery(args, api, extraOptions); }
        }
        return result;
    } catch {
        return { error: { status: 500, data: 'Token retrieval failed' } } as any;
    }
};

export interface ApiResponse<T> {
    success: boolean
    message?: string
    data?: T
    error?: string
}

export const sustainabilityRptAPI = createApi({
    reducerPath: 'sustainabilityRptAPI',
    baseQuery: authBaseQuery,
    tagTypes: ['jobservice'],
    endpoints: (builder) => ({

        getSustainabilityReport: builder.query<SustainabilityReportEntity[], { request: SustainabilityReportRequestEntity }>({
            query: ({ request }) => ({
                url: `SustainabilityReport/GetSustainabilityReport`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: request,
            }),
            providesTags: ['jobservice'],
        }),
         getSustainabilityReportToExport: builder.query<SustainabilityReportEntity[], { request: SustainabilityReportRequestEntity }>({
            query: ({ request }) => ({
                url: `SustainabilityReport/GetSustainabilityReportToExport`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: request,
            }),
            providesTags: ['jobservice'],
        }),        
        
    }),
});

export const {
    useGetSustainabilityReportQuery,
    useGetSustainabilityReportToExportQuery,

} = sustainabilityRptAPI;
